/* @ngInject */
const ask = (
  commandeData,
  commandeFormat,
  utils,
  commandeLocal,
  commandeLabels,
  toaster,
  valueHandler,
  commandeRequest
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(commandeLabels.ask.delete)) {
      try {
        const message = await commandeRequest.delete(_id)

        toaster.message(message)
        utils.removeFromArray(commandeData.myCommandes, _id)
        if (_back) {
          utils.$back()
        }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.update = async (_commande, _wagonIds, _back = false) => {
    let commande = utils.copy(_commande)
    commande.id = commandeLocal.getCurrentId()
    commande = commandeFormat.server(commande)

    try {
      const response = await commandeRequest.update(commande, _wagonIds)
      toaster.message(response.message)
      utils.updateFromArray(commandeData.myCommandes, response.commande)
      if (_back) {
        utils.$back()
      }
    } catch (error) {
      toaster.error(error)
    }
  }

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/services/ask.service.js